import React, { useCallback, useState } from "react"
import { gql, useMutation } from "@apollo/client"

import { Formik, Form, FieldArray } from "formik"
import * as yup from "yup"

import Layout from "components/Layout"

import { Fieldset, Modal } from "components"

import { useAuth } from "hooks/useAuth"
// import isEmpty from "lodash/isEmpty"

import { toast } from "react-hot-toast"

/**
 *
 * Inspiration
 * https://tailwindui.com/components/application-ui/page-examples/settings-screens
 * https://tailwindui.com/components/application-ui/forms/form-layouts
 *
 */

const diff = (o1, o2) =>
  Object.keys(o2).reduce((diff, key) => {
    if (o1[key] === o2[key]) return diff
    return {
      ...diff,
      [key]: o2[key],
    }
  }, {})

const BoxHeader = ({ onSearch, onClick }) => {
  const [query, setQuery] = useState("")

  // useEffect(() => {
  //   onSearch && onSearch(query)
  // }, [query])

  return (
    <header className="bg-gray-800 text-gray-100 pb-24">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 py-8 grid grid-cols-12 gap-4">
        <div className="col-span-3 flex items-center">
          <h1 className="font-black text-3xl">Account</h1>
        </div>

        {/* <div className="col-span-6 relative">
          <div className="absolute inset-y-0 left-0 flex items-center pl-4">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 fill-current text-gray-600"
            >
              <path d="M16.32 14.9l1.1 1.1c.4-.02.83.13 1.14.44l3 3a1.5 1.5 0 0 1-2.12 2.12l-3-3a1.5 1.5 0 0 1-.44-1.14l-1.1-1.1a8 8 0 1 1 1.41-1.41l.01-.01zM10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z" />
            </svg>
          </div>
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search"
            className="block w-full border border-transparent bg-gray-900 focus:outline-none focus:bg-white focus:border-gray-300 text-gray-900 rounded-lg pl-12 pr-4 py-2"
          />
        </div> */}

        {/* <div className="col-span-3 flex justify-end items-center pl-8">
          <button
            onClick={onClick}
            type="button"
            className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="-ml-1 mr-2 h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
              />
            </svg>
            Create User
          </button>
        </div> */}
      </div>
    </header>
  )
}

const Settings = () => {
  const [selectedTab, setSelectedTab] = useState(0)

  const tabs = [
    {
      title: "Profile",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      ),
    },
    {
      title: "Password",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"
          />
        </svg>
      ),
    },
    {
      title: "Notification",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
          />
        </svg>
      ),
    },

    //TODO show only if user.role === admin
    // {
    //   title: "System",
    //   icon: (
    //     <svg
    //       xmlns="http://www.w3.org/2000/svg"
    //       className="h-6 w-6"
    //       fill="none"
    //       viewBox="0 0 24 24"
    //       stroke="currentColor"
    //     >
    //       <path
    //         strokeLinecap="round"
    //         strokeLinejoin="round"
    //         strokeWidth={2}
    //         d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
    //       />
    //     </svg>
    //   ),
    // },
  ]

  const tabContainers = [
    <ProfileSettingsForm />,
    <PasswordSettingsForm />,
    <NotificationSettingsForm />,
    // <SystemSettingsForm />,
  ]

  const ActiveTab = () => tabContainers[selectedTab]

  return (
    <Layout>
      <BoxHeader />

      <main className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 pb-32">
        <div className="relative -mt-16 z-30">
          <div className="bg-white rounded-lg flex justify-between">
            <div className="w-3/12 border-r-2 border-gray-200 py-6">
              <ul className="text-sm">
                {tabs.map((tab, index) => (
                  <li
                    onClick={() => setSelectedTab(index)}
                    className={`border-l-4 pl-2 py-3 flex items-center space-x-2 ${
                      index === selectedTab &&
                      "bg-green-100 text-green-800 border-green-800 font-bold"
                    } hover:bg-green-100 cursor-pointer`}
                  >
                    {tab.icon}
                    <span>{tab.title}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="flex-1 py-3 px-6">
              <ActiveTab />
            </div>
          </div>
        </div>
      </main>
    </Layout>
  )
}

export default Settings

//Components
const FormHeader = ({ title, subtitle }) => {
  return (
    <header className="px-2 py-3">
      <h1 className="text-base leading-normal font-medium text-gray-900">
        {title}
      </h1>
      <p className="text-sm text-gray-500">{subtitle}</p>
    </header>
  )
}

const UPDATE_PROFILE = gql`
  mutation UpdateProfile($input: UpdateUserProfileInput!) {
    updateProfile(input: $input) {
      id
      displayName
      email
      phoneNumber
      photoURL
    }
  }
`

// const phoneRegExp =
//   /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

const e164 = /^\+?[1-9]\d{1,14}$/

const accountSettingSchema = yup.object().shape({
  displayName: yup.string().required("Name is required"),
  email: yup.string().required("Email is required"),
  phoneNumber: yup
    .string()
    .matches(e164, "Phone number is not valid")
    .notRequired()
    .nullable(),
  // photoURL: yup.mixed().oneOf([
  //   yup
  //     .object()
  //     .shape({
  //       url: yup.string().required("Photo is required"),
  //     })
  //     .nullable()
  //     .required("Cover image is required"),
  //   yup.string(),
  // ]),
})

const ProfileSettingsForm = () => {
  const { user, reloadCurrentUser } = useAuth()
  const [updateProfile] = useMutation(UPDATE_PROFILE)

  const accountSettingsModel = {
    displayName: "",
    email: "",
    phoneNumber: "",
    photoURL: "",

    // email: 'modifiedUser@example.com',
    // phoneNumber: '+11234567890',
    // emailVerified: true,
    // password: 'newPassword',
    // displayName: 'Jane Doe',
    // photoURL: 'http://www.example.com/12345678/photo.png',
    // disabled: true,

    // photoURL: `https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80`,
    // phoneNumber: "+38162607456",
  }

  const formikProps = {
    initialValues: { ...accountSettingsModel, ...user },
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: accountSettingSchema,
    onSubmit: useCallback(async (values, actions) => {
      try {
        actions.setSubmitting(true)
        // const changed = diff(accountSettingsModel, values)

        // if (!isEmpty(changed)) {
        //   await updateProfile(changed)
        // }

        const input = {
          ...values,
          photoURL: values.photoURL.url,
          // photoURL: `https://firebasestorage.googleapis.com/v0/b/grouptravelres.appspot.com/o/img%2F0jxq2cegk-67402179_1476955749095770_2253648182925852672_n.jpg?alt=media&token=62313a49-2ace-4289-ad45-da96d7c411b3`,
          // photoURL: `https://sumaleeboxinggym.com/wp-content/uploads/2018/06/Generic-Profile-1600x1600.png`,
        }

        await toast.promise(
          updateProfile({ variables: { input } }).then(reloadCurrentUser),
          {
            loading: "Saving...",
            success: <b>Account updated!</b>,
            error: <b>Could not save.</b>,
          },
        )
      } catch (e) {
        actions.setSubmitting(false)
        const errors = e.graphQLErrors.map((v) => v)
        actions.setFieldError("server", errors)
      }
    }),
  }

  return (
    <>
      <FormHeader title="Profile" subtitle="Update your profile settings" />

      <Formik {...formikProps}>
        {({ errors, isSubmitting }) => (
          <Form>
            <div className="px-2 py-3 w-3/12 ">
              <Fieldset
                component="image"
                multiple={false}
                library={false}
                variant="round"
                name="photoURL"
                label="Avatar"
                preload={true}
              />
            </div>

            <div className="px-2 py-3 w-6/12">
              <Fieldset name="displayName" label="Full name " type="text" />
            </div>

            <div className="px-2 py-3 w-6/12">
              <Fieldset name="email" label="Email" type="email" />
            </div>

            <div className="px-2 py-3 w-6/12">
              <Fieldset
                name="phoneNumber"
                label="Phone"
                type="phone"
                // placeholder="[+][country code][subscriber number including area code]"
              />
            </div>

            {errors?.server?.map((error) => (
              <div role="alert">
                <div className="bg-red-500 text-white font-bold rounded-t px-4 py-2">
                  {error.code}
                </div>
                <div className="border border-t-0 border-red-400 rounded-b bg-red-100 px-4 py-3 text-red-700">
                  <p>{error.message}</p>
                </div>
              </div>
            ))}

            <div className=" px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
              <span className="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
                <button
                  disabled={isSubmitting}
                  type="submit"
                  className="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green transition ease-in-out duration-150 sm:text-sm sm:leading-5 disabled:opacity-50 disabled:cursor-wait"
                >
                  Save
                </button>
              </span>
            </div>
          </Form>
        )}
      </Formik>
    </>
  )
}

const PasswordSettingsForm = () => {
  const { reauthenticate, updatePassword } = useAuth()

  const passwordSettingsModel = {
    password: "",
    passwordConfirmation: "",
  }

  const passwordResetSchema = yup.object().shape({
    currentPassword: yup.string().required("Password is required"),
    password: yup
      .string()
      .required("Password is required")
      .min(8, "Password is too short - should be 8 chars minimum.")
      .matches(/[a-zA-Z]/, "Password can only contain Latin letters."),
    passwordConfirmation: yup
      .string()
      .required("Password confirmation is required")
      .test("passwords-match", "Passwords must match", function (value) {
        return this.parent.password === value
      }),
  })

  const formikProps = {
    initialValues: { ...passwordSettingsModel },
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: passwordResetSchema,
    onSubmit: useCallback(async (values, actions) => {
      try {
        actions.setSubmitting(true)

        await toast.promise(
          reauthenticate(values.currentPassword).then(() =>
            updatePassword(values.password),
          ),
          {
            loading: "Saving...",
            success: <b>Password updated!</b>,
            error: <b>Could not save.</b>,
          },
        )
      } catch (e) {
        actions.setSubmitting(false)
        const errors = e.graphQLErrors ? e.graphQLErrors.map((v) => v) : [e]
        actions.setFieldError("server", errors)
      }
    }),
  }

  return (
    <>
      <FormHeader title="Password" subtitle="Update your password settings" />

      <Formik {...formikProps}>
        {({ values, errors, isSubmitting }) => (
          <Form>
            <div className="px-2 py-3 w-6/12">
              <Fieldset
                name="currentPassword"
                label="Current Password"
                type="password"
              />
            </div>

            <div className="px-2 py-3 w-6/12">
              <Fieldset name="password" label="New Password" type="password" />
            </div>

            <div className="px-2 py-3 w-6/12">
              <Fieldset
                name="passwordConfirmation"
                label="New Password retype"
                type="password"
              />
            </div>

            {errors?.server?.map((error) => (
              <div role="alert">
                <div className="bg-red-500 text-white font-bold rounded-t px-4 py-2">
                  {error?.code}
                </div>
                <div className="border border-t-0 border-red-400 rounded-b bg-red-100 px-4 py-3 text-red-700">
                  <p>{error?.message}</p>
                </div>
              </div>
            ))}

            <div className="px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
              <span className="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
                <button
                  disabled={isSubmitting}
                  type="submit"
                  className="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green transition ease-in-out duration-150 sm:text-sm sm:leading-5 disabled:opacity-50 disabled:cursor-wait"
                >
                  Save
                </button>
              </span>
            </div>
          </Form>
        )}
      </Formik>
    </>
  )
}

const NotificationSettingsForm = () => {
  const { updatePassword } = useAuth()

  const formikProps = {
    initialValues: {
      notifcations: {
        bookingCreated: false,
        bookingConfirmation: false,
        bookingReserved: false,
      },
    },
    validateOnBlur: false,
    validateOnChange: false,
    // validationSchema: createTripSchema,
    onSubmit: useCallback(async (values, actions) => {
      try {
        actions.setSubmitting(true)

        const p = Promise.all([])
        await toast.promise(p, {
          loading: "Saving...",
          success: <b>Notifcations updated!</b>,
          error: <b>Could not save.</b>,
        })
      } catch (e) {
        actions.setSubmitting(false)
        const errors = e.graphQLErrors ? e.graphQLErrors.map((v) => v) : [e]
        actions.setFieldError("server", errors)
      }
    }),
  }

  return (
    <>
      <FormHeader
        title="Notification"
        subtitle="Update your notification settings"
      />

      <Formik {...formikProps}>
        {({ values, isSubmitting }) => (
          <Form>
            <div className="px-2 py-3 w-6/12">
              {[
                { label: "Booking created", value: "bookingCreated" },
                { label: "Booking confirmation", value: "bookingConfirmation" },
                { label: "Booking reserved", value: "bookingReserved" },
              ].map((field, index) => (
                <div key={index} className="px-2 py-3">
                  <Fieldset
                    component="switch"
                    name={`notifcations.${field.value}`}
                    label={field.label}
                  />
                </div>
              ))}
            </div>

            <div className="px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
              <span className="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
                <button
                  disabled={isSubmitting}
                  type="submit"
                  className="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green transition ease-in-out duration-150 sm:text-sm sm:leading-5 disabled:opacity-50 disabled:cursor-wait"
                >
                  Save
                </button>
              </span>
            </div>
          </Form>
        )}
      </Formik>
    </>
  )
}
